<template>
  <div
    class="qooBox-main flex flex-col overflow-hidden"
    :style="{ height: `${windowsHeight}px` }"
  >
    <MainHeader v-if="$route.meta.layout == 'default'" />
    <div
      class="grow flex flex-col"
      :class="{ 'router-view-content': $route.meta.layout == 'default' }"
      :style="{ height: `${windowsHeight - 72}px` }"
    >
      <router-view />
    </div>
  </div>
  <OverlayLoader v-show="isLoading" />
  <popup-modal
    :w="windowsWidth > 768 ? '60%' : '100%'"
    :headerClass="'!mb-[18px]'"
    class="max-md:!items-start max-md:!h-full"
    classList="p-4 sm:p-4 md:py-6 md:px-6 mainList rounded-[14px] max-md:max-w-[100%] 
               max-md:!h-full max-md:max-h-[100%] max-md:w-[100%] hide-scrollbar "
    @close="worksheet.popupMainWorksheet = false"
    v-show="worksheet.popupMainWorksheet"
    :title="'Add suite to your worksheet:'"
    :typeClose="'text'"
  >
    <div>
      <div
        v-if="
          worksheet.popupMainWorksheet &&
          floorplan &&
          floorplan.floorplanList &&
          floorplan.floorplanList.length
        "
      >
        <tablePopupWorksheet
          :classSelection="'!mt-[34px]'"
          :btnPos="'bottom'"
          :isTitle="false"
          @close="handleClosePopup()"
          @save="save"
          :floorplanList="floorplan.floorplanList"
          :selected="selected"
          :worksheetList="worksheet.worksheetId"
          @showDet="showDet"
        >
        </tablePopupWorksheet>
      </div>
    </div>
  </popup-modal>
</template>

<script setup>
// import PopupModal from "@/components/worksheet/popupWorksheet.vue";
import PopupModal from "@/components/base/PopupModalAnimation.vue";

import tablePopupWorksheet from "@/components/worksheet/tablePopupWorksheet.vue";
import OverlayLoader from "@/components/base/overlay/OverlayLoader.vue";
import MainHeader from "@/components/base/MainHeader";
import {
  computed,
  onMounted,
  watch,
  onUnmounted,
  ref,
  onBeforeMount,
} from "vue";
import { useStore } from "@/store/loading.js";
import { useWindowSize } from "@vueuse/core";
import { useWorksheets } from "@/store/worksheet.js";
import { useFloorplan } from "@/store/floor.js";
// import socket from "@/util/socket.js";
const { height: windowsHeight, width: windowsWidth } = useWindowSize();

let floorplan = {};
const selected = ref(-1);
const popupMainWorksheetModels = ref(false);
const store = useStore();
const worksheet = useWorksheets();
const isLoading = computed(() => {
  return store.isLoading || worksheet.isLoading;
});

const handleClosePopup = () => {
  worksheet.popupMainWorksheet = false;
  selected.value = -1;
};

onBeforeMount(() => {
  // matomo
  const projectId = localStorage.getItem("project_id");
  const organizationId = localStorage.getItem("organization_id");
  const userId = localStorage.getItem("user_id");
  const email = localStorage.getItem("email");

  if (userId) {
    window._paq.push(["setUserId", userId]);
  }
  if (email) {
    window._paq.push(["setCustomDimension", 1, email]);
  }
  if (organizationId) {
    window._paq.push(["setCustomDimension", 2, String(organizationId)]);
    window._paq.push(["setCustomDimension", 5, String(organizationId)]);
  }
  if (projectId) {
    window._paq.push(["setCustomDimension", 3, String(projectId)]);
    window._paq.push(["setCustomDimension", 4, String(projectId)]);
  }
});

onMounted(() => {
  floorplan = useFloorplan();
  worksheet.ensureWorksheetsLength();
  if (store.numberOfAjaxCAllPending == 0) {
    store.mutationer({ isLoading: false });
  }
});

watch(
  () => worksheet.popupMainWorksheet,
  () => {
    if (popupMainWorksheetModels.value != worksheet.popupMainWorksheet)
      popupMainWorksheetModels.value = worksheet.popupMainWorksheet;
    selected.value = -1;
  },
);

watch(
  () => popupMainWorksheetModels,
  () => {
    if (popupMainWorksheetModels.value != worksheet.popupMainWorksheet)
      worksheet.popupMainWorksheet = popupMainWorksheetModels.value;
  },
);

const save = (e) => {
  worksheet.addWorksheet(e);
  worksheet.popupMainWorksheet = false;
};

const showDet = (e) => {
  // console.log("showDet e", e);
  if (selected.value === e) {
    selected.value = -1;
  } else selected.value = e;
};

onUnmounted(() => {
  // socket.off("message");
});
</script>

<style lang="scss">
.mainList {
  .floorplans .vgt-table.bordered th {
    font-size: 16px;
    font-weight: 500;
  }
  h3 {
    font-size: 16px !important;
    font-weight: 500 !important;
  }
  .vgt-responsive {
    height: 40vh !important;
    min-height: 20vh;
    max-height: calc(100vh - 20.5rem);
  }
  .vgt-table {
    width: 100%;
    thead {
      th {
        text-align: start;
      }
      tr th:first-child {
        max-width: 80px;
      }
    }
    colgroup {
      col:first-child {
        max-width: 80px;
        width: 80px;
      }
    }
    td {
      .grid {
        padding: 16px;
      }
    }
  }
}
.g {
  color: #ef45234d;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
